import { http } from './config'

export default {
  getAllVehicleBays: () => {
    return http.get('vehicle_bays')
  },
  getVehicleBaysByLoadID: loadID => {
    return http.get('vehicle_bays/?load_id=' + loadID)
  },
  getVehicleBaysDraggableByLoadID: loadID => {
    return http.get('vehicle_bays_draggable/?load_id=' + loadID)
  },
}
